import React from 'react';
import TierPromotionCardSemiDumb from '../../../../DeviationViews/TierPromotionCardSemiDumb';
import s from './Tier.scss';
var TierThumbReactView = function (_a) {
    var deviation = _a.deviation, width = _a.width, height = _a.height;
    return (React.createElement("div", { className: s['root'], style: { width: width, height: height } },
        React.createElement(TierPromotionCardSemiDumb, { width: width, height: height, deviation: deviation, ctaButton: "subscribe" })));
};
TierThumbReactView.displayName = 'TierThumbReactView';
export default TierThumbReactView;
//# sourceMappingURL=Tier.js.map